const injectRobotsMetaTag = (): void => {
    const tag: HTMLMetaElement = document.createElement('meta');
    tag.setAttribute('name', 'robots');
    tag.setAttribute('content', 'noindex, nofollow');

    document.head.appendChild(tag);
};

export { injectRobotsMetaTag };
